import { useMemo } from 'react'
import { useUser } from '@/stores/app'
import { usePermissionStore } from '@/stores/permission'
import type { MenuItem } from '@/types/menu'

export function useFilteredMenu(menuItems: MenuItem[]): MenuItem[] {
	const { hasPermission } = usePermissionStore()
	const { user } = useUser()
	const isSupplier = Boolean(user?.crmeb_uid && user.crmeb_uid > 0)

	const filterMenu = (items: MenuItem[]): MenuItem[] => {
		return items
			.map(item => ({
				...item,
				children: item.children ? filterMenu(item.children) : undefined,
			}))
			.filter(item => {
				if (item.supplierOnly && !isSupplier) {
					return false
				}
				if (item.children !== undefined) {
					return item.children.length > 0
				}
				return hasPermission(item.permission)
			})
	}

	return useMemo(() => filterMenu(menuItems), [menuItems, hasPermission, isSupplier])
}
